// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__Xcubg","title":"AfterBackImages_title__eYtMR","images":"AfterBackImages_images__2IC1q"};